import React, {useMemo} from 'react';
import {Select} from "antd";
import {IPropsElement} from "../../../pages/ChecklistPage/PopupEdit/constants";
import {filterOption} from '../../../util/varibles/global';
import {callEventChecklist, getChecklist, useChecklist} from "../ChecklistContext";


const DropdownElement: React.FC<IPropsElement> = (props) => {
    const {options = '', multipleSelections, optionDefault} = props.properties;
    const {index} = props;
    const [value = optionDefault] = useChecklist(state => state.result[index]);
    const {onResultChange} = callEventChecklist();
    const {disabled} = getChecklist()();

    const attrSelect: any = multipleSelections ? {mode: "multiple", className:'select-mode-tag'} : {};

    const opts = useMemo(() => {
        if (options.length === 0)
            return []
        return options.split('\n').map((item, index) => ({value: `${index}`, label: item}))
    }, [options]);

    return <Select
        {...attrSelect}
        disabled={disabled}
        filterOption={filterOption}
        options={opts}
        value={value}
        onChange={value => onResultChange({[index]: value})}
    />
};

export default DropdownElement;
